import 'whatwg-fetch'
import '@babel/polyfill'
import LazyLoad from "vanilla-lazyload"
import cookies from './modules/cookies'
import router from './modules/router'

/**
 * Lazyload
 */
var lazyLoadInstance = new LazyLoad({
  elements_selector: '.lazy',
  class_loading: 'lazy-loading',
  class_loaded: 'lazy-loaded',
  threshold: 300
})

const activeLocation = location.pathname
const isProductPage = /\/products\/[^\/]+$/.test(activeLocation)
const isCollectionPage = /^\/collections\/[^\/]+$/.test(activeLocation)
const isAccountPage = /^\/account/.test(activeLocation)

/**
 * Shipping selector
 */
const shippingSelector = document.querySelector('.shippingSelector')
const stores =  Array.from(shippingSelector.querySelectorAll('.shippingSelector_store'))
const closeStoreSelector = shippingSelector.querySelector('.shippingSelector_close')
const switchStoreButtons =  Array.from(document.querySelectorAll('.switchStoreButton'))
const preferredStoreCookie = cookies.getCookie('preferred_store') || null
const currentStore = document.body.id
const switchedToStore = window.location.search
const showShippingSelector = shippingSelector.getAttribute('data-show-on-load')

// Show shipping selector based on data attribute from settings schema. Expecting either true or false
if(showShippingSelector === 'true') {
  showStoreSelector()
}

if(switchedToStore.indexOf('?shipping_destination=') > -1) {
  let storeName = switchedToStore.split('&')[0].split('=')[1]
  hideStoreSelector()
  cookies.setCookie('preferred_store', storeName, 7)
} else if (preferredStoreCookie === currentStore) {
  hideStoreSelector()
}

function showStoreSelector() {
  shippingSelector.classList.add('shippingSelector-active')
}

function hideStoreSelector() {
  shippingSelector.classList.remove('shippingSelector-active')
}

closeStoreSelector.addEventListener('click', function(event) {
  event.preventDefault()
  hideStoreSelector()
})

switchStoreButtons.forEach(button => {
  button.addEventListener('click', function(event) {
    event.preventDefault()
    cookies.setCookie('preferred_store', null, 7)
    showStoreSelector()
  })
})

stores.forEach(store => {
  store.addEventListener('click', function(event) {
    let storeName = store.getAttribute('data-shop-name') || null
    if(storeName === currentStore) {
      event.preventDefault()
      hideStoreSelector()
    }
    cookies.setCookie('preferred_store', storeName, 7)
  })
})

if (isCollectionPage) {
  /**
   * Expandable collection descriptions
   */
  var readMoreText = Shopify.ReadMoreText
  var readLessText = Shopify.ReadLessText
  let expandableTexts = Array.from(document.querySelectorAll('.expandableText'))

  expandableTexts.forEach(function(expandableText) {
    let button = expandableText.querySelector('.expandableText_button') || null
    
    if (button) {
      button.addEventListener('click', function(event) {
        event.preventDefault()

        if (expandableText.classList.contains('expandableText-expanded')) {
          expandableText.classList.remove('expandableText-expanded')
          button.innerHTML = readMoreText
        } else {
          expandableText.classList.add('expandableText-expanded')
          button.innerHTML = readLessText
        }
      })
    }
  })
}


/**
 * 
 * @param {*} pid product id
 * @param {*} qty quantity
 * @param {*} e function
 */

var iconTick = `<svg xmlns="http://www.w3.org/2000/svg" class="tick" viewBox="0 0 50 50" version="1.1" role="img"><title>Tick</title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><polygon fill="#FFFFFF" fill-rule="nonzero" points="14.6553946 35.392902 5.19935444 25.8272493 0 31.0869305 12.4784711 43.7100827 12.4927896 43.6954946 14.7708631 46 50 10.3619014 44.6998024 5"></polygon></g></svg>`
var iconSpinner = `<svg xmlns="http://www.w3.org/2000/svg" class="spinner" width="24" height="24" viewBox="0 0 24 24" role="img"><title>Loading</title><g fill="none" fill-rule="evenodd" stroke="none" stroke-width="1"><path fill="#fff" d="M12 5.25v1.5a5.25 5.25 0 105.246 5.466L17.25 12h1.5a6.75 6.75 0 11-6.987-6.746L12 5.25z"></path></g></svg>`

window.addItemToCart = function(btn, pid, qty, e) {
  const indicators = `<span class="button_indicators">${iconTick}${iconSpinner}</span>`
  btn.insertAdjacentHTML('beforeend', indicators);
  var indicatorElem = btn.getElementsByClassName('button_indicators')[0];
  indicatorElem.classList.add('add-success-loading');
  var inventoryQty = btn.getAttribute('data-qty');

  // var productHandle = btn.getAttribute('data-handle')

  // jQuery.getJSON(`/products/${productHandle}.js`, function(product) {
  //   console.log(JSON.stringify(product));
  // });

  var o = {
    type: "POST",
    url: "/cart/add.js",
    data: "quantity=" + (qty = qty || 1) + "&id=" + pid,
    dataType: "json",
    success: function (pid) {
      setTimeout(function() {
        window.showCart();
        indicatorElem.classList.remove('add-success-loading');
        indicatorElem.classList.add('add-success-added');

        setTimeout(function() {
          indicatorElem.classList.remove('add-success-added');
          indicatorElem.remove();
          if (inventoryQty) {
            inventoryQty--
            btn.setAttribute('data-qty', inventoryQty)
  
            if (inventoryQty <= 0) {
              btn.disabled = true;
            }
          }
        }, 1500);
      }, 1000);
    },
    error: function() {
      // alert('Something went wrong. Try again');
      indicatorElem.remove();
    },
  };
  jQuery.ajax(o);
}
